module.exports = __webpack_public_path__ + "static/media/cc-amex.9f26e905.svg";